import * as GetLatestFilledAptitudeTestTypes from 'src/actions/filled-test/get/Types';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import {
  GetLatestFilledAptitudeTestAction,
  GetLatestFilledAptitudeTestSuccess
} from 'src/actions/filled-test/get/GetLatestFilledAptitudeTest.actions';

export interface GetLatestFilledAptitudeTestState {
  filledAptitudeTest?: FilledAptitudeTest;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetLatestFilledAptitudeTestState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetLatestFilledAptitudeTestReducer(state: GetLatestFilledAptitudeTestState = initialState,
                                                   action: GetLatestFilledAptitudeTestAction):
  GetLatestFilledAptitudeTestState {
  switch (action.type) {
    case GetLatestFilledAptitudeTestTypes.GET_LATEST_FILLED_APTITUDE_TEST_ATTEMPT:
      return {...state, filledAptitudeTest: undefined, loading: true, error: false};
    case GetLatestFilledAptitudeTestTypes.GET_LATEST_FILLED_APTITUDE_TEST_SUCCESS:
      const filledAptitudeTest: FilledAptitudeTest =
        (action as GetLatestFilledAptitudeTestSuccess).payload.aptitudeTest;
      return {...state, filledAptitudeTest: filledAptitudeTest, loading: false, error: false};
    case GetLatestFilledAptitudeTestTypes.GET_LATEST_FILLED_APTITUDE_TEST_FAILURE:
      return {
        ...state,
        filledAptitudeTest: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filled-test/GetLatestFilledAptitudeTestReducer.tsx